export const Categories = {
  Coffee: 'coffee',
  PetFood: 'pet-food',
  Byo: 'byo',
  HealthAndFitness: 'health-and-fitness',
};
